import { FieldValues, useController } from 'react-hook-form'
import { formatISO } from 'date-fns'
import { RhfProps } from './rhf.props'
import { DatePickerFieldProps } from '../date-picker-field/date-picker.props'
import { DatePickerField } from '../date-picker-field/date-picker-field'

export type DatePickerFieldRhf<T extends FieldValues> = RhfProps<T> & DatePickerFieldProps

export function DatePickerFieldRhf<T extends FieldValues>({
  name,
  defaultValue,
  control,
  rules = {},
  required,
  ...datePickerProps
}: DatePickerFieldRhf<T>) {
  if (required) {
    rules.required = 'This field is required'
  }
  const startController = useController({
    name,
    control,
    rules,
    defaultValue,
  })

  let hasError = !!startController.fieldState.error
  const convertToDate = (date: Date | string | null) =>
    !date ? null : typeof date === 'string' ? new Date(date) : date
  const isDirty = startController.fieldState.isDirty

  return (
    <DatePickerField
      {...datePickerProps}
      startDate={startController.field.value ? convertToDate(startController.field.value) : null}
      isRangePicker={false}
      required={!!rules?.required}
      onChange={(data) => {
        const startValue = data.startDate
          ? formatISO(data.startDate, { representation: 'date' })
          : ''
        startController.field.onChange(startValue)
      }}
      helperText={hasError ? startController.fieldState.error?.message : datePickerProps.helperText}
      error={hasError}
      isDirty={isDirty}
    />
  )
}
